<template>
  <vue-qrcode :value="valueQrcode" :options="{ width: localWidth }"></vue-qrcode>
</template>

<script>
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'QrCodeComponent',
  components: {
    VueQrcode
  },
  data: () => ({
    localWidth: null
  }),
  props: {
    appApiKey: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: false,
      default: 280
    }
  },
  computed: {
    valueQrcode() {
      let str = `acrdx://${window.location.host}/link/${this.appApiKey}`
      return str
    }
  },
  created() {
    this.localWidth = this.width

    if (this.width === 280) {
      this.setQRWidtn(window.innerWidth)
      window.addEventListener('resize', this.setQRWidtn)
    }
  },
  methods: {
    setQRWidtn(e) {
      let width = Number.isInteger(e) ? e : e.currentTarget.innerWidth
      if (width < 680 && this.localWidth) {
        this.localWidth = 150
      } else if (width < 768 && this.localWidth) {
        this.localWidth = 180
      } else if (width < 992 && this.localWidth) {
        this.localWidth = 220
      } else {
        this.localWidth = 280
      }
    }
  }
}
</script>
